import {NotificationTypeEnum} from '../../../../shared/NotificationTypes.ts'
import {type NotificationItemViewData, UINotificationItemViewBase} from './UINotificationItemViewBase.ts'
import {type BigId, LobbyImage} from '@colonist/types'
import {UIOnlineFriendController} from '../ui_friends/UIOnlineFriendController.ts'
import {UIUtilsFriends} from '../ui_friends/UIUtilsFriends.ts'

export type CTANotificationTypeData =
{
    type: NotificationTypeEnum.LiveRoomInvite
    roomId: string
    senderUsername: string
    senderUserId: BigId
    senderIcon: LobbyImage
} | {
    type: NotificationTypeEnum.FriendRequestReceived
    username: string
}

export interface CTANotificationData {
    typeData: CTANotificationTypeData
    dateReceived: Date
}

export class UICTANotificationView extends UINotificationItemViewBase {
    constructor(notificationData: CTANotificationData, parentContainer: HTMLElement) {
        super('', notificationData.dateReceived, parentContainer)

        this.viewData = UICTANotificationView.getViewData(notificationData.typeData)

        this.createBaseNotification(notificationData.dateReceived)
        this.createResponseButtons()
        this.setClickActions()
        this.removeContentHoverEffectIfNoClickAction()
    }

    private static getViewData(notificationTypeData: CTANotificationTypeData): NotificationItemViewData {
        switch(notificationTypeData.type) {
            case NotificationTypeEnum.LiveRoomInvite:
                return {
                    text: {key: 'strings:roomPage.userInvitedToRoom', options: {username: notificationTypeData.senderUsername, roomId: notificationTypeData.roomId}},
                    image: notificationTypeData.senderIcon,
                    responseButtons: {
                        acceptButtonAction: () => UIOnlineFriendController.respondToFriendRoomInvite(notificationTypeData.roomId, true, notificationTypeData.senderUserId),
                        ignoreButtonAction: () => UIOnlineFriendController.respondToFriendRoomInvite(notificationTypeData.roomId, false, notificationTypeData.senderUserId),
                    },
                }
            case NotificationTypeEnum.FriendRequestReceived:
                return {
                    text: {key: 'strings:popups.notification.userSentYouFriendRequest', options: {username: notificationTypeData.username}},
                    image: LobbyImage.Friends,
                    responseButtons: {
                        acceptButtonAction: () => {
                            void UIUtilsFriends.friendRequestResponded(notificationTypeData.username, true)
                        },
                        ignoreButtonAction: () => {
                            void UIUtilsFriends.friendRequestResponded(notificationTypeData.username, false)
                        },
                    },
                }
        }
    }
}
